const services = [
  {
    id: "curated-product-sourcing",
    title: "Curated Product Sourcing",
    desc: "We take pride in simplifying the design and sourcing process through our expertly curated showroom that brings together globally renowned interior and exterior brands. Whether you're working on a residential, commercial, or hospitality project, our collection features high-end materials and finishes that meet both aesthetic and functional demands. With leading names like Momenti, Antonio Liso, JR Stone, Top Ciment, and 1810 Sinks under one roof, clients can explore a diverse yet cohesive selection of products ranging from elegant wall finishes to luxury flooring and custom lighting. Our curation is more than just convenience—it’s about sparking ideas, inspiring innovation, and making it easier for designers, architects, and homeowners to bring their vision to life with confidence and clarity.",
    img: "/images/service-img-1175277391991.png"
  },
  {
    id: "bespoke-surface-finish-solutions",
    title: "Bespoke Surface & Finish Solutions",
    desc: "We offer custom surface solutions—from Venetian plaster to marble countertops—expertly crafted to enhance Luxe Cucine kitchens and luxury interiors with style and function.",
    img: "/images/bespoke175865471667.jpg"
  },
  {
    id: "design-consultation-collaboration",
    title: "Design Consultation & Collaboration",
    desc: "We partner with design professionals to turn concepts into refined spaces, offering expert guidance, material pairing, and aesthetic alignment from start to finish.",
    img: "/images/corian-plus-sink1175865487471.jpg"
  },
  {
    id: "integrated-brand-partnerships",
    title: "Integrated Brand Partnerships",
    desc: "Through exclusive partnerships with top brands, we offer clients unique collections, innovative finishes, and custom solutions—all curated in our concept showroom.",
    img: "/images/ser2175862649739.webp"
  },
  {
    id: "luxury-kitchen-bath-enhancements",
    title: "Luxury Kitchen & Bath Enhancements",
    desc: "We provide bespoke kitchen and bath solutions featuring Luxe Cucine cabinetry, premium finishes, and 1810 sinks—combining Italian design with personalized luxury.",
    img: "/images/vegetables-ver175857788764.jpg"
  },
  {
    id: "trade-support-for-professionals",
    title: "Trade Support for Professionals",
    desc: "Design professionals trust our expert support—from material selection to specification—to streamline projects while ensuring creative freedom and precise execution.",
    img: "/images/tone_athroom175865506296175883589887.jpg"
  }
];

export default services;
